import {Component, Input, OnInit} from '@angular/core';
import {KlinikaxpPaymentRequiredReservation} from "../../models/klinikaxp-payment-required-reservation.model";
import {ModalController} from "@ionic/angular";

@Component({
  selector: 'app-klinikaxp-reservation-details-modal',
  templateUrl: './klinikaxp-reservation-details-modal.component.html',
  styleUrls: ['./klinikaxp-reservation-details-modal.component.scss'],
})
export class KlinikaxpReservationDetailsModalComponent implements OnInit {

  @Input() klinikaxpPaymentRequiredReservation: KlinikaxpPaymentRequiredReservation;
  @Input() title: string;
  @Input() isGeneralAdmin;

  constructor(private modalController: ModalController) { }

  ngOnInit() {}

  onClose() {
    this.modalController.dismiss();
  }

  getSubject() {
    return this.klinikaxpPaymentRequiredReservation.isMedicalProcedure ? 'Temat (zabieg):' : 'Temat';
  }
}
